import * as React from "react";
import * as styles from "./Sunlight.css";

export function Sunlight() {
    const lightRef = React.useRef<HTMLSpanElement>(null);
    React.useLayoutEffect(() => {
        const light = lightRef.current;
        if (!light) return;
        const alignSun = () => {
            const { width, height } = light.getBoundingClientRect();
            // Match background-size: cover and background-position: center 12%.
            const scale = Math.max(width / 1122, height / 1402);
            light.style.setProperty("--sun-x", `${(width - 1122 * scale) / 2 + 602 * scale}px`);
            light.style.setProperty("--sun-y", `${(height - 1402 * scale) * 0.12 + 365 * scale}px`);
        };
        alignSun();
        const observer = new ResizeObserver(alignSun);
        observer.observe(light);
        return () => observer.disconnect();
    }, []);
    return (
        <span ref={lightRef} className={styles.light} aria-hidden="true">
            <span className={styles.shade} />
            <span className={styles.rays} />
            <span className={styles.crossRays} />
            <span className={styles.glint} />
        </span>
    );
}
